import type { Permission } from '../types/role'

export function getPermissionGroup(name: string): string {
  const lastDash = name.lastIndexOf('-')

  if (lastDash <= 0) {
    return 'general'
  }

  return name.slice(0, lastDash)
}

export function formatPermissionGroupLabel(group: string): string {
  return group
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}

export function formatPermissionAction(name: string): string {
  const lastDash = name.lastIndexOf('-')

  if (lastDash < 0) {
    return name
  }

  return name
    .slice(lastDash + 1)
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}

export function groupPermissions(permissions: Permission[]): Array<{ group: string; items: Permission[] }> {
  const map = new Map<string, Permission[]>()

  for (const permission of permissions) {
    const group = getPermissionGroup(permission.name)
    const items = map.get(group) ?? []
    items.push(permission)
    map.set(group, items)
  }

  return Array.from(map.entries())
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([group, items]) => ({
      group,
      items: items.sort((left, right) => left.name.localeCompare(right.name)),
    }))
}
